import ApiService from "@/core/services/api.service";

// action types
export const POPULATE_ACTIVITY_NOTIFICATIONS = "populateActivityNotifications";
export const POPULATE_ACTIVITY_SETTINGS = "populateActivitySettings";
export const POPULATE_ACTIVITY_QUESTION_SETTINGS = "populateActivityQuestionSettings";
export const POPULATE_ACTIVITY_STAGES = "populateActivityStages";
export const POPULATE_ACTIVITY_TYPES = "populateActivityTypes";
export const POPULATE_ADMIN_ROLES = "populateAdminRoles";
export const POPULATE_ANSWER_TYPES = "populateAnswerTypes";
export const POPULATE_CLIENT_ROLES = "populateClientRoles";
export const POPULATE_COUNTRIES = "populateCountries";
export const POPULATE_GENDERS = "populateGenders";
export const POPULATE_LANGUAGES = "populateLanguages";
export const POPULATE_MARKUP_PIN_TYPES = "populateMarkupPinTypes";
export const POPULATE_NOTIFY_METHODS = "populateNotifyMethods";
export const POPULATE_PAGE_TYPES = "populatePageTypes";
export const POPULATE_PROFILE_QUESTIONS = "populateProfileMethods";
export const POPULATE_PROJECT_ROLES = "populateProjectRoles";
export const POPULATE_PROJECT_STAGES = "populateProjectStages";
export const POPULATE_PROJECT_USER_SAMPLES = "populateProjectUserSamples";
export const POPULATE_PROJECT_TEMPLATE_TYPES = "populateProjectTemplateTypes";
export const POPULATE_ROOM_SETUPS = "populateRoomSetups";
export const POPULATE_SEGMENT_CLASSES = "populateSegmentClasses";
export const POPULATE_SOCIAL_BIAS = "populateSocialBias";
export const POPULATE_SOCIAL_SETTING = "populateSocialSetting";
export const POPULATE_TIMEZONES = "populateTimezones";
export const POPULATE_USER_REGISTER_TYPE = "populateUserRegisterType";
export const POPULATE_WIDGET_TYPES = "populateWidgetTypes";

// mutation types
export const SET_ACTIVITY_NOTIFICATIONS = "setActivityNotifications";
export const SET_ACTIVITY_SETTINGS = "setActivitySettings";
export const SET_ACTIVITY_QUESTION_SETTINGS = "setActivityQuestionSettings";
export const SET_ACTIVITY_STAGES = "setActivityStages";
export const SET_ACTIVITY_TYPES = "setActivityTypes";
export const SET_ADMIN_ROLES = "setAdminRoles";
export const SET_ANSWER_TYPES = "setAnswerTypes";
export const SET_CLIENT_ROLES = "setClientRoles";
export const SET_COUNTRIES = "setCountries";
export const SET_GENDERS = "setGenders";
export const SET_LANGUAGES = "setLanguages";
export const SET_MARKUP_PIN_TYPES = "setMarkupPinTypes";
export const SET_NOTIFY_METHODS = "setNotifyMethods";
export const SET_PAGE_TYPES = "setPageTypes";
export const SET_PROFILE_QUESTIONS = "setProfileQuestions";
export const SET_PROJECT_ROLES = "setProjectRoles";
export const SET_PROJECT_SETTING_CATEGORIES = "setProjectSettingCategories";
export const SET_PROJECT_STAGES = "setProjectStages";
export const SET_PROJECT_USER_SAMPLES = "setProjectUserSamples";
export const SET_PROJECT_TEMPLATE_TYPES = "setProjectTemplateTypes";
export const SET_ROOM_SETUPS = "setRoomSetups";
export const SET_SEGMENT_CLASSES = "setSegmentClasses";
export const SET_SOCIAL_BIAS = "setSocialBias";
export const SET_SOCIAL_SETTING = "setSocialSetting";
export const SET_TIMEZONES = "setTimezones";
export const SET_USER_REGISTER_TYPE = "setUserRegisterType";
export const SET_WIDGET_TYPES = "setWidgetTypes";

const state = {
  activity_notifications: [],
  activity_settings: [],
  activity_question_settings: [],
  activity_stages: [],
  activity_types: [],
  admin_roles: [],
  answer_types: [],
  client_roles: [],
  countries: [],
  genders: [],
  languages: [],
  markup_pin_types: [],
  notifiy_methods: [],
  page_types: [],
  profile_questions: [],
  project_roles: [],
  project_setting_categories: [],
  project_stages: [],
  project_samples: [],
  project_template_types: [],
  room_setups: [],
  segment_classes: [],
  social_bias: [],
  social_setting: [],
  timezones: [],
  user_register_types: [],
  widget_types: []
};

const getters = {
  systemActivityNotifications(state) {
    return state.activity_notifications;
  },
  systemActivitySettings(state) {
    return state.activity_settings;
  },
  systemActivityQuestionSettings(state) {
    return state.activity_question_settings;
  },
  systemActivityStages(state) {
    return state.activity_stages;
  },
  systemActivityTypes(state) {
    return state.activity_types;
  },
  systemAdminRoles(state) {
    return state.admin_roles;
  },
  systemAnswerTypes(state) {
    return state.answer_types;
  },
  systemClientRoles(state) {
    return state.client_roles;
  },
  systemCountries(state) {
    return state.countries;
  },
  systemGenders(state) {
    return state.genders;
  },
  systemLanguages(state) {
    return state.languages;
  },
  systemMarkupPinTypes(state) {
    return state.markup_pin_types;
  },
  systemNotifyMethods(state) {
    return state.notifiy_methods;
  },
  systemPageTypes(state) {
    return state.page_types;
  },
  systemProfileQuestions(state) {
    return state.profile_questions;
  },
  systemProjectRoles(state) {
    return state.project_roles;
  },
  systemProjectSettingCategories(state) {
    return state.project_setting_categories;
  },
  systemProjectStages(state) {
    return state.project_stages;
  },
  systemProjectUserSamples(state) {
    return state.project_samples;
  },
  systemProjectTemplateTypes(state) {
    return state.project_template_types;
  },
  systemRoomSetups(state) {
    return state.room_setups;
  },
  systemSegmentClasses(state) {
    return state.segment_classes;
  },
  systemSocialBias(state) {
    return state.social_bias;
  },
  systemSocialSetting(state) {
    return state.social_setting;
  },
  systemTimezones(state) {
    return state.timezones;
  },
  systemUserRegisterTypes(state) {
    return state.user_register_types;
  },
  systemWidgetTypes(state) {
    return state.widget_types;
  }
};

const actions = {
  [POPULATE_ACTIVITY_NOTIFICATIONS](context) {
    return ApiService.get("api/v1/system_activity_notifications", {
      params: {
        paginate: false
      }
    }).then(res => {
      let activity_notifictions =
        res.data.data._embedded.system_activity_notifications;
      context.commit(SET_ACTIVITY_NOTIFICATIONS, activity_notifictions);
    });
  },
  [POPULATE_ACTIVITY_SETTINGS](context) {
    return ApiService.get("api/v1/system_activity_settings", {
      params: {
        paginate: false
      }
    }).then(res => {
      let activity_settings = res.data.data._embedded.system_activity_settings;
      context.commit(SET_ACTIVITY_SETTINGS, activity_settings);
    });
  },
  [POPULATE_ACTIVITY_QUESTION_SETTINGS](context) {
    return ApiService.get("api/v1/system_activity_question_settings", {
      params: {
        paginate: false
      }
    }).then(res => {
      let activity_question_settings = res.data.data._embedded.system_activity_question_settings;
      context.commit(SET_ACTIVITY_QUESTION_SETTINGS, activity_question_settings);
    });
  },
  [POPULATE_ACTIVITY_STAGES](context) {
    return ApiService.get("api/v1/system_activity_stages", {
      params: {
        paginate: false
      }
    }).then(res => {
      let activity_stages = res.data.data._embedded.system_activity_stages;
      context.commit(SET_ACTIVITY_STAGES, activity_stages);
    });
  },
  [POPULATE_ACTIVITY_TYPES](context) {
    return ApiService.get("api/v1/system_activity_types", {
      params: {
        paginate: false
      }
    }).then(res => {
      let activity_types = res.data.data._embedded.system_activity_types;
      context.commit(SET_ACTIVITY_TYPES, activity_types);
    });
  },
  [POPULATE_ADMIN_ROLES](context) {
    return ApiService.get("api/v1/system_admin_roles", {
      params: {
        paginate: false
      }
    }).then(res => {
      let admin_roles = res.data.data._embedded.system_admin_roles;
      context.commit(SET_ADMIN_ROLES, admin_roles);
    });
  },
  [POPULATE_ANSWER_TYPES](context) {
    return ApiService.get("api/v1/system_answer_types", {
      params: {
        paginate: false
      }
    }).then(res => {
      let answer_types = res.data.data._embedded.system_answer_types;
      context.commit(SET_ANSWER_TYPES, answer_types);
    });
  },
  [POPULATE_CLIENT_ROLES](context) {
    return ApiService.get("api/v1/system_client_roles", {
      params: {
        paginate: false
      }
    }).then(res => {
      let client_roles = res.data.data._embedded.system_client_roles;
      context.commit(SET_CLIENT_ROLES, client_roles);
    });
  },
  [POPULATE_COUNTRIES](context) {
    return ApiService.get("api/v1/system_countries", {
      params: {
        paginate: false
      }
    }).then(res => {
      let countries = res.data.data._embedded.system_countries;
      context.commit(SET_COUNTRIES, countries);
    });
  },
  [POPULATE_GENDERS](context) {
    return ApiService.get("api/v1/system_genders", {
      params: {
        paginate: false
      }
    }).then(res => {
      let genders = res.data.data._embedded.system_genders;
      context.commit(SET_GENDERS, genders);
    });
  },
  [POPULATE_LANGUAGES](context) {
    return ApiService.get("api/v1/system_languages", {
      params: {
        paginate: false
      }
    }).then(res => {
      let languages = res.data.data._embedded.system_languages;
      context.commit(SET_LANGUAGES, languages);
    });
  },
  [POPULATE_MARKUP_PIN_TYPES](context) {
    return ApiService.get("api/v1/system_markup_pin_types", {
      params: {
        paginate: false
      }
    }).then(res => {
      let pin_types = res.data.data._embedded.system_markup_pin_types;
      context.commit(SET_MARKUP_PIN_TYPES, pin_types);
    }); 
  },
  [POPULATE_NOTIFY_METHODS](context) {
    return ApiService.get("api/v1/system_notify_methods", {
      params: {
        paginate: false
      }
    }).then(res => {
      let notify_methods = res.data.data._embedded.system_notify_methods;
      context.commit(SET_NOTIFY_METHODS, notify_methods);
    });
  },
  [POPULATE_PAGE_TYPES](context) {
    return ApiService.get("api/v1/system_page_types", {
      params: {
        paginate: false
      }
    }).then(res => {
      let page_types = res.data.data._embedded.system_page_types;
      context.commit(SET_PAGE_TYPES, page_types);
    });
  },
  [POPULATE_PROFILE_QUESTIONS](context) {
    return ApiService.get("api/v1/system_profile_questions", {
      params: {
        paginate: false
      }
    }).then(res => {
      let profile_questions = res.data.data._embedded.system_profile_questions;
      context.commit(SET_PROFILE_QUESTIONS, profile_questions);
    });
  },
  [POPULATE_PROJECT_ROLES](context) {
    return ApiService.get("api/v1/system_project_roles", {
      params: {
        paginate: false
      }
    }).then(res => {
      let project_roles = res.data.data._embedded.system_project_roles;
      context.commit(SET_PROJECT_ROLES, project_roles);
    });
  },
  [POPULATE_PROJECT_STAGES](context) {
    return ApiService.get("api/v1/system_project_stages", {
      params: {
        paginate: false
      }
    }).then(res => {
      let project_stages = res.data.data._embedded.system_project_stages;
      context.commit(SET_PROJECT_STAGES, project_stages);
    });
  },
  [POPULATE_PROJECT_USER_SAMPLES](context) {
    return ApiService.get("api/v1/system_project_user_samples", {
      params: {
        paginate: false
      }
    }).then(res => {
      let user_samples = res.data.data._embedded.system_project_user_samples;
      context.commit(SET_PROJECT_USER_SAMPLES, user_samples);
    });
  },
  [POPULATE_PROJECT_TEMPLATE_TYPES](context) {
    return ApiService.get("api/v1/system_project_template_types", {
      params: {
        paginate: false
      }
    }).then(res => {
      let template_types = res.data.data._embedded.system_project_template_types;
      context.commit(SET_PROJECT_TEMPLATE_TYPES, template_types);
    });
  },
  [POPULATE_ROOM_SETUPS](context) {
    return ApiService.get("api/v1/system_room_setups", {
      params: {
        paginate: false
      }
    }).then(res => {
      let room_setups = res.data.data._embedded.system_room_setups;
      context.commit(SET_ROOM_SETUPS, room_setups);
    });
  },
  [POPULATE_SEGMENT_CLASSES](context) {
    return ApiService.get("api/v1/system_segment_classes", {
      params: {
        paginate: false
      }
    }).then(res => {
      let segment_classes = res.data.data._embedded.system_segment_classes;
      context.commit(SET_SEGMENT_CLASSES, segment_classes);
    });
  },
  [POPULATE_SOCIAL_BIAS](context) {
    return ApiService.get("api/v1/system_social_bias", {
      params: {
        paginate: false
      }
    }).then(res => {
      let social_bias = res.data.data._embedded.system_social_bias;
      context.commit(SET_SOCIAL_BIAS, social_bias);
    });
  },
  [POPULATE_SOCIAL_SETTING](context) {
    return ApiService.get("api/v1/system_social_settings", {
      params: {
        paginate: false
      }
    }).then(res => {
      let social_settings = res.data.data._embedded.system_social_settings;
      context.commit(SET_SOCIAL_SETTING, social_settings);
    });
  },
  [POPULATE_TIMEZONES](context) {
    return ApiService.get("api/v1/system_timezones", {
      params: {
        paginate: false
      }
    }).then(res => {
      let timezones = res.data.data._embedded.system_timezones;
      context.commit(SET_TIMEZONES, timezones);
    });
  },
  [POPULATE_USER_REGISTER_TYPE](context) {
    return ApiService.get("api/v1/system_user_register_types", {
      params: {
        paginate: false
      }
    }).then(res => {
      let registerTypes = res.data.data._embedded.system_user_register_types;
      context.commit(SET_USER_REGISTER_TYPE, registerTypes);
    });
  },
  [POPULATE_WIDGET_TYPES](context) {
    return ApiService.get("api/v1/system_widget_types", {
      params: {
        paginate: false
      }
    }).then(res => {
      let widget_types = res.data.data._embedded.system_widget_types;
      context.commit(SET_WIDGET_TYPES, widget_types);
    });
  }
};

const mutations = {
  [SET_ACTIVITY_NOTIFICATIONS](state, activity_notifictions) {
    state.activity_notifictions = activity_notifictions;
  },
  [SET_ACTIVITY_SETTINGS](state, activity_settings) {
    state.activity_settings = activity_settings;
  },
  [SET_ACTIVITY_QUESTION_SETTINGS](state, activity_question_settings) {
    state.activity_question_settings = activity_question_settings;
  },
  [SET_ACTIVITY_STAGES](state, activity_stages) {
    state.activity_stages = activity_stages;
  },
  [SET_ACTIVITY_TYPES](state, activity_types) {
    state.activity_types = activity_types;
  },
  [SET_ADMIN_ROLES](state, admin_roles) {
    state.admin_roles = admin_roles;
  },
  [SET_ANSWER_TYPES](state, answer_types) {
    state.answer_types = answer_types;
  },
  [SET_CLIENT_ROLES](state, client_roles) {
    state.client_roles = client_roles;
  },
  [SET_COUNTRIES](state, countries) {
    state.countries = countries;
  },
  [SET_GENDERS](state, genders) {
    state.genders = genders;
  },
  [SET_LANGUAGES](state, languages) {
    state.languages = languages;
  },
  [SET_MARKUP_PIN_TYPES](state, markupPinTypes) {
    state.markup_pin_types = markupPinTypes;
  },
  [SET_NOTIFY_METHODS](state, notifiy_methods) {
    state.notifiy_methods = notifiy_methods;
  },
  [SET_PAGE_TYPES](state, page_types) {
    state.page_types = page_types;
  },
  [SET_PROFILE_QUESTIONS](state, profile_questions) {
    state.profile_questions = profile_questions;
  },
  [SET_PROJECT_ROLES](state, project_roles) {
    state.project_roles = project_roles;
  },
  [SET_PROJECT_SETTING_CATEGORIES](state, project_setting_categories) {
    state.project_setting_categories = project_setting_categories;
  },
  [SET_PROJECT_STAGES](state, project_stages) {
    state.project_stages = project_stages;
  },
  [SET_PROJECT_USER_SAMPLES](state, project_samples) {
    state.project_samples = project_samples;
  },
  [SET_PROJECT_TEMPLATE_TYPES](state, project_template_types) {
    state.project_template_types = project_template_types;
  },
  [SET_ROOM_SETUPS](state, room_setups) {
    state.room_setups = room_setups;
  },
  [SET_SEGMENT_CLASSES](state, segment_classes) {
    state.segment_classes = segment_classes;
  },
  [SET_SOCIAL_BIAS](state, social_bias) {
    state.social_bias = social_bias;
  },
  [SET_SOCIAL_SETTING](state, social_setting) {
    state.social_setting = social_setting;
  },
  [SET_TIMEZONES](state, timezones) {
    state.timezones = timezones;
  },
  [SET_USER_REGISTER_TYPE](state, registerTypes) {
    state.user_register_types = registerTypes;
  },
  [SET_WIDGET_TYPES](state, widget_types) {
    state.widget_types = widget_types;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
